import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'
import type { IButtonGroupProps } from '../ButtonGroup'

import { SecondaryOpacityFavoriteToggleButton } from 'atoms/ActionButton/Templates'
import {
  DetailsSecondaryOpacityButton,
  PlayPrimaryButton,
} from 'atoms/Button/Templates'
import { ButtonGroup } from '../ButtonGroup'

export interface IButtonGroupTemplate1Props extends Omit<
  IButtonGroupProps,
  'children'
> {
  list: [IButtonProps['title'], IButtonProps['title']?]
}

export const ButtonGroupTemplate1 = ({
  list,
  ...rest
}: IButtonGroupTemplate1Props): JSX.Element => (
  <ButtonGroup {...rest}>
    <PlayPrimaryButton title={list?.[0] || ''} />
    {list?.[1] && <DetailsSecondaryOpacityButton title={list?.[1] || ''} />}
    <SecondaryOpacityFavoriteToggleButton />
  </ButtonGroup>
)
